// Yazarkasa Bağlı Değil / Yazarkasa Hatası pencereleri kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'sales.fiscalWarning';

export const fiscalWarningGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Yazarkasa uyarısında ne yapmalı?'),
  intro: t(`${G}.intro`, 'Bu pencereler, ödeme sırasında yazarkasaya ulaşılamadığında veya yazarkasa hata verdiğinde çıkar. Seçiminiz satışın sisteme kaydedilip kaydedilmeyeceğini ve mali fiş kesilip kesilmeyeceğini belirler. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Uyarı türü'),
    body: t(`${G}.regions.body`, 'Durum ve cihaz sorgusu'),
    footer: t(`${G}.regions.footer`, 'Seçenekler'),
  },
  steps: [
    {
      region: 'header',
      title: t(`${G}.s1.title`, '1. Hangi uyarı çıktı?'),
      text: t(`${G}.s1.text`, '"Yazarkasa Bağlı Değil!": ödeme başlarken yazarkasaya bağlanılamadı; nakit, POS ve karma (parçalı) ödemede çıkabilir. "Yazarkasa Hatası": Ingenico 5000F cihazında nakit ödeme sırasında cihaz hata döndü; para alınmış olabilir, kontrol etmeniz gerekir.'),
      tips: [
        t(`${G}.s1.tip1`, 'Nakit ve POS ödemesindeki bağlantı uyarısı Ekran Ayarları > Ödeme Yöntemleri\'ndeki "Bağlantı Uyarısı" ile açılıp kapatılır. Kapalıysa yazarkasa bağlı olmasa bile satış uyarı göstermeden, fişsiz kaydedilir.'),
        t(`${G}.s1.tip2`, 'Karma ödemede bağlantı uyarısı bu ayardan bağımsız olarak her zaman sorulur.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s2.title`, '2. Yazarkasa Bağlı Değil: devam mı, iptal mi?'),
      text: t(`${G}.s2.text`, '"✅ EVET, DEVAM ET" satışı yazarkasa olmadan sisteme kaydeder: stok düşer, tutar nakit kasaya veya POS\'un banka hesabına işlenir, ancak mali fiş kesilmez ("Bu işlem mali kayıt oluşturmayacaktır!"). "❌ İPTAL" hiçbir kayıt oluşturmaz; sepet ekranda kalır, bağlantıyı düzeltip ödemeyi yeniden alabilirsiniz.'),
      tips: [
        t(`${G}.s2.tip1`, 'POS ödemesinde devam ederseniz sistem kartı yazarkasadan çekmez. Ödemeyi başka bir POS cihazından aldığınızdan emin olun.'),
        t(`${G}.s2.tip2`, 'Beko 300TR / X30TR zorunlu mali cihazdır: "EVET, DEVAM ET" pasiftir, bağlantı kurulmadan ödeme tamamlanamaz.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Yazarkasa Hatası: önce ödemeyi kontrol edin'),
      text: t(`${G}.s3.text`, '"🔎 ÖDEMEYİ KONTROL ET (CİHAZI SORGULA)" cihazdaki fişin gerçek durumunu okur. Sonuç pencerede görünür: ödeme alınmış ve fiş kapatılmışsa satışı kaydedin; kısmi ödeme varsa kalan tutarı cihazdan tamamlayın veya cihazdan iptal edip tekrar sorgulayın.'),
      tips: [
        t(`${G}.s3.tip1`, '"Fişte henüz ödeme görünmüyor": fişe dokunulmaz. Cihaz ödeme ekranında bekliyor olabilir; ödeme sürüyorsa bitmesini bekleyip yeniden sorgulayın.'),
        t(`${G}.s3.tip2`, '"Açık işlem var ancak detayları okunamadı": cihazdaki işlemi sonuçlandırıp yeniden sorgulayın.'),
        t(`${G}.s3.tip3`, '"Açık işlem bulunamadı": durum kesin değil. Fiş çıktıysa "Yine de Devam Et", çıkmadıysa "İptal" deyip tekrar deneyin.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Fişi iptal et (ödeme alınmadıysa)'),
      text: t(`${G}.s4.text`, '"🗑️ FİŞİ İPTAL ET (ÖDEME ALINMADIYSA)" yalnız sorgu "ödeme görünmüyor" dediğinde çıkar ve cihazdaki açık fişi siler. Başarılı olursa "İptal" deyip ödemeyi güvenle yeniden alabilirsiniz. Para alındıysa bu düğmeye basmayın.'),
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Yine de devam et ya da kaydetme'),
      text: t(`${G}.s5.text`, '"✅ YİNE DE DEVAM ET (SATIŞI KAYDET)" satışı nakit kasaya kaydeder ve stoku düşer; yazarkasadan YENİ fiş kesilmez. Yalnız parayı gerçekten aldıysanız kullanın. "❌ İPTAL (SATIŞI KAYDETME)" sistemde kayıt oluşturmaz.'),
      tips: [
        t(`${G}.s5.tip1`, 'Para alındığı halde "İptal" derseniz satış kayıtsız kalır ve gün sonunda kasa fazlası çıkar.'),
        t(`${G}.s5.tip2`, '"Yine de Devam Et" sonrası aynı satışı tekrar ödemeye almayın; satış iki kez kaydedilir.'),
      ],
    },
  ],
});
